import styled from 'styled-components'
import { Trash2 } from 'lucide-react'
import { BORDER_RADIUS, TRANSITIONS } from '../../../../styles/theme'

export const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  background: transparent;
  border: none;
  border-radius: ${BORDER_RADIUS.sm};
  cursor: pointer;
  transition: ${TRANSITIONS.all};
  opacity: 1;
`

export const StyledTrashIcon = styled(Trash2)<{ $isHovered: boolean }>`
  color: ${(props) => (props.$isHovered ? '#ef4444' : 'var(--color-text-secondary)')};
  transition: ${TRANSITIONS.fast};
`
